<template>
  <ul :class="style['bottom-panel-option']" ref="optionPicker">
    <li
      v-for="option in optionList"
      :class="addSelectedClass(option)"
      @click="updateSelectedOption(option)"
      :ref="addSelectedClass(option) ? 'defaultSelected' : undefined"
    >{{ option.text }}</li>
  </ul>
</template>

<script>
import style from '../scss/_bottompanel.scss'

export default {
  props: {
    optionList: {
      type: Array,
      required: true
    },
    selectedOptionId: Number,
    updateSelectedOption: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      style
    }
  },
  mounted () {
    const dom = this.$refs.defaultSelected
    const offsetTop = (dom && dom[0] && dom[0].offsetTop - 175) || 0
    this.$refs.optionPicker.scroll(0, offsetTop)
  },
  methods: {
    addSelectedClass (option) {
      return option.id === this.selectedOptionId && style['selected']
    }
  }
}
</script>
